const tails = new Map<string, Promise<unknown>>();

/** 同一标签页的所有 IP 写入口共用锁；失败取消已排队操作，后续新操作可重新入队。 */
export function enqueueMyIpWrite<T>(ipId: string, write: (waited: boolean) => Promise<T>): Promise<T> {
  const previous = tails.get(ipId);
  // 等待过其他写请求时必须重新读取详情，不能沿用入队时的版本或关系 ID。
  const pending = (previous ?? Promise.resolve()).then(() => write(Boolean(previous)));
  /** 只清理本任务仍持有的队尾，避免早完成的请求释放后来者的锁。 */
  const release = () => {
    if (tails.get(ipId) === pending) tails.delete(ipId);
  };
  tails.set(ipId, pending);
  // 保留失败传播到已入队的请求，同时在队尾结束时释放锁。
  pending.then(release, release);
  return pending;
}
